<template>
  <div>
    <b-card title="Protestos" id="painelProtestos">
      <b-row class="destaque2" id="destaquesProtestos">
        <b-col md="6" class="d-flex flex-column justify-content-center my-2">
          <div>
            <div class="mx-auto passo-p passo_inativo">
              <img
                src="@/assets/img/icones/cda.png"
                alt="Quantidade de CDAs disponibilizadas pela SEFA no mês de referência"
                v-b-tooltip.hover
                title="Total de CDAs direcionadas para Protesto"
              />
            </div>
            <template v-if="resultado.qtdeGeralProtesto != null">
              <div class="destaque1-p">CDA´s: {{resultado.qtdeGeralProtesto}}</div>
            </template>
            <template v-else>
              <div class="destaque1-p">Carregando..</div>
            </template>
          </div>
        </b-col>
        <b-col md="6" class="d-flex flex-column justify-content-center my-2">
          <div>
            <div class="mx-auto passo-p passo_inativo">
              <img
                src="@/assets/img/icones/movimentacao.png"
                alt="Quantidade de CDAs disponibilizadas pela SEFA no mês de referência"
                v-b-tooltip.hover
                title="Valor das CDAs direcionadas para Protesto"
              />
            </div>
            <template v-if="resultado.valorGeralProtesto != null">
              <div class="destaque1-p">Valor Total: R$ {{resultado.valorGeralProtesto | currency}}</div>
            </template>
             <template v-else>
              <div class="destaque1-p">Carregando..</div>
            </template>
          </div>
        </b-col>
      </b-row>
      <b-row class="justify-content-between" id="primeiraLinhaProtestos">
        <Item
          titulo="CDA's Disponíveis"
          icone="images/icones/cda.png"
          link="/protesto/cda-disponivel-protesto"
          tooltip="CDAs disponíveis para seleção do Protesto"
          :quantidade="resultado.qtdeDisponiveisProtesto"
          :valor="resultado.valorDisponiveisProtesto"
        />
        <b-col lg="1">
          <div class="seta">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </div>
        </b-col>
        <Item
          titulo="CDA's Selecionadas"
          icone="images/icones/protocolado_off.png"
          link="/protesto/cda-selecionadas-protesto"
          tooltip="CDAs selecionadas e pendentes de envio para Protesto"
          :quantidade="resultado.qtdeSelecionadasProtesto"
          :valor="resultado.valorSelecionadasProtesto"
        />
        <b-col lg="1">
          <div class="seta">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </div>
        </b-col>
        <Item
          titulo="Enviadas para Protesto"
          icone="images/icones/arquivado1_off.png"
          link="/protesto/exibir-dividas-enviadas-protesto"
          tooltip="CDAs enviadas para Protesto"
          :quantidade="resultado.qtdeEnviadasProtesto"
          :valor="resultado.valorEnviadasProtesto"
        />
      </b-row>
      <b-row class="justify-content-between" id="segundaLinhaProtestos">
        <Item
          titulo="Exceções"
          icone="images/icones/deferido_off.png"
          link="/protesto/exibir-excecoes-protesto"
          tooltip="CDAs retiradas em razão da lista de exceção"
          :quantidade="resultado.qtdeExcecoesProtesto"
          :valor="resultado.valorExcecoesProtesto"
        />
        <!-- <b-col lg="1"><div class="seta"><i class="fa fa-arrow-right" aria-hidden="true"></i></div></b-col> -->
        <Item
          titulo="Erros"
          icone="images/icones/erro_off.png"
          link="/protesto/exibir-erros-protesto"
          tooltip="CDAs que apresentaram erro durante o processamento do Protesto"
          :quantidade="resultado.qtdeErrosProtesto"
          :valor="resultado.valorErrosProtesto"
        />
        <!-- <b-col lg="1"><div class="seta"><i class="fa fa-arrow-right" aria-hidden="true"></i></div></b-col> -->
        <Item
          titulo="Excluídas"
          icone="images/icones/excluidas.png"
          link="/protesto/exibir-excluidas-protesto"
          tooltip="CDAs excluídas por informação de pagamento, parcelamento ou retificações na SEFA"
          :quantidade="resultado.qtdeExcluidasProtesto"
          :valor="resultado.valorExcluidasProtesto"
        />
      </b-row>
    </b-card>

    <b-card>
      <b-row class="diferenca-totais" id="diferencaTotaisProtestos">
        <b-col md="6" class="d-flex flex-column justify-content-center my-2">
          <template v-if="resultado.qtdeGeralProtesto != null">
            <div>CDA´s: {{somaQuantidadeProtestos}}
              <span style="color:red"><span v-if="diferencaQuantidadeProtestos > 0">
                &#8800; {{diferencaQuantidadeProtestos}}</span></span>
            </div>
          </template>
          <template v-else>
            <div>Carregando..</div>
          </template>
        </b-col>
        <b-col md="6" class="d-flex flex-column justify-content-center my-2">
          <template v-if="resultado.valorGeralProtesto != null">
            <div>Valor Total: R$ {{somaValoresProtestos | currency}}
              <span style="color:red"><span v-if="diferencaValoresProtestos > 0">
                &#8800; R$ {{diferencaValoresProtestos | currency}}</span>
              </span>
            </div>
          </template>
          <template v-else>
            <div>Carregando..</div>
          </template>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>



<script>
import Item from "./CompItem";
import axios from 'axios'

export default {
  components: {
    Item
  },
  data() {
    return {
      ano: null,
      mes: null,
      somaQuantidadeProtestos: null,
      somaValoresProtestos: null,
      diferencaQuantidadeProtestos: null,
      diferencaValoresProtestos: null,
      resultado: []
    }
  },
  methods: {
      async consultarProtesto(ano,mes) {
            this.ano = ano;
            this.mes = mes;
            this.resultado = [];
            this.somaQuantidadeProtestos = 0;
            this.somaValoresProtestos = 0;
            this.diferencaQuantidadeProtestos = 0;
            this.diferencaValoresProtestos = 0;

            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/monitoramentoDividas/consultarProtesto/${this.ano}/${this.mes}`, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.resultado = response.data;
                this.calcularDiferencas();
            }).finally(() => {
                this.$emit('atualizarDadosGerais')
            })
        },
        obterValorGeral(){
          return this.resultado.valorGeralProtesto;
        },
        obterQtdeGeral(){
          return this.resultado.qtdeGeralProtesto;
        },
        calcularDiferencas(){
          this.calcularDiferencaCdas();
          this.calcularDiferencaValorTotal();
        },
        calcularDiferencaCdas(){
          if(this.resultado.qtdeGeralProtesto != null){
            this.somaQuantidadeProtestos = this.resultado.qtdeDisponiveisProtesto + this.resultado.qtdeSelecionadasProtesto +
                this.resultado.qtdeEnviadasProtesto + this.resultado.qtdeExcecoesProtesto + this.resultado.qtdeErrosProtesto +
                this.resultado.qtdeExcluidasProtesto;
            this.somaQuantidadeProtestos = Math.round((this.somaQuantidadeProtestos + Number.EPSILON) * 100) / 100;
            this.diferencaQuantidadeProtestos = this.resultado.qtdeGeralProtesto - this.somaQuantidadeProtestos;
            if(this.diferencaQuantidadeProtestos < 0) {
                this.diferencaQuantidadeProtestos = this.diferencaQuantidadeProtestos * -1;
            }
          }
        },
        calcularDiferencaValorTotal(){
          if(this.resultado.valorGeralProtesto != null){
            this.somaValoresProtestos = this.resultado.valorDisponiveisProtesto + this.resultado.valorSelecionadasProtesto +
                this.resultado.valorEnviadasProtesto + this.resultado.valorExcecoesProtesto + this.resultado.valorErrosProtesto +
                this.resultado.valorExcluidasProtesto;
            this.somaValoresProtestos = Math.round((this.somaValoresProtestos + Number.EPSILON) * 100) / 100;
            this.diferencaValoresProtestos = this.resultado.valorGeralProtesto - this.somaValoresProtestos;
            if(this.diferencaValoresProtestos < 0) {
                this.diferencaValoresProtestos = this.diferencaValoresProtestos * -1;
            }
          }
        }
  },
};
</script>


<style scoped>
.card-title {
  text-align: center;
  font-size: 1.5rem;
}
</style>
